import { Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TwoInputField from "../../../components/TwoInputField";
import SingleInputField from "../../../components/SingleInputField";
import { userSelectedData } from "../../../assets/lib/user.js";
import { useMediaQuery } from "@mui/material";
import { CircularLoader } from "../../../components/widgets/CircularLoader";
import { ErrorText } from "../../../components";

const customStyle = makeStyles({
  root: { width: "100%", display: "flex", flexDirection: "column" },
  formContainer: {
    padding: "10px 40px 40px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    overflowY: "scroll",
  },
  actionBtn: { display: "flex", justifyContent: "end" },
  editBtn: { display: "flex", padding: "10px 40px 5px", justifyContent: "end" },
});

const Layout = ({
  isEdit,
  setIsEdit,
  isNewAdd,
  getUserInput,
  userState,
  handleSubmitModal,
  errorFields,
  fetchLoading,
  submitLoading,
  errorOnFetch,
}) => {
  const classes = customStyle();
  const isPhone = useMediaQuery("(max-width: 390px)");

  return fetchLoading ? (
    <CircularLoader />
  ) : errorOnFetch ? (
    <ErrorText />
  ) : (
    <div className={classes.root}>
      {submitLoading && <CircularLoader isPoistionAbsolute />}
      {!isNewAdd && (
        <div className={classes.editBtn}>
          {!isEdit && (
            <Button variant="outlined" onClick={() => setIsEdit(true)}>
              <EditIcon /> Edit Page
            </Button>
          )}
        </div>
      )}

      <div className={classes.formContainer}>
        <AccountCircleIcon sx={{ fontSize: isPhone ? "60px" : "120px", color: "#808080" }} />

        <TwoInputField
          content={userSelectedData.no}
          value={userState.no}
          isEditable={false}
          secondContent={userSelectedData.userName}
          secondValue={userState.userName}
          getInputData={getUserInput}
          errorFields={errorFields}
        />

        <TwoInputField
          content={userSelectedData.email}
          value={userState.email}
          secondContent={userSelectedData.phoneNumber}
          secondValue={userState.phoneNumber}
          getInputData={getUserInput}
          errorFields={errorFields}
        />

        <TwoInputField
          content={userSelectedData.alpin}
          value={userState.alpin}
          secondContent={userSelectedData.status}
          secondValue={userState.status}
          getInputData={getUserInput}
          errorFields={errorFields}
        />

        <TwoInputField
          content={userSelectedData.goCoins}
          value={userState.goCoins}
          secondContent={userSelectedData.walletAmount}
          secondValue={userState.walletAmount}
          getInputData={getUserInput}
          errorFields={errorFields}
        />

        <SingleInputField
          content={userSelectedData.createdTimestamp}
          value={userState.createdTimestamp}
          getInputData={getUserInput}
          errorFields={errorFields}
        />

        {(isEdit || isNewAdd) && (
          <div className={classes.actionBtn}>
            <Button variant="contained" color="primary" onClick={handleSubmitModal}>
              {isEdit ? "Save Changes" : "Submit"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Layout;
